import { useEffect, useState } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function AnnouncementBar() {
  const { settings } = useSettings();
  const msgs = settings.announcements?.length ? settings.announcements : [settings.announcement || "PROTOCOL · EST 2026"];
  const [i, setI] = useState(0);
  useEffect(() => {
    if (msgs.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % msgs.length), 4500);
    return () => clearInterval(t);
  }, [msgs.length]);
  return (
    <div className="bg-[#1D1D1B] text-[#F7F5F1] text-center py-2.5 px-4" data-testid="announcement-bar">
      <p key={i} className="font-mono text-[0.62rem] uppercase tracking-[0.28em] reveal-up">{msgs[i]}</p>
    </div>
  );
}
